"use client";
import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footersection';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  return (
    <div>
      <div className="w-full">
        <Header />
      </div>
      <main className="flex gap-7 p-10 w-full min-h-screen bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
        <section className="flex flex-col flex-1 gap-5 min-w-0">
          <div className="bg-gray-50 min-h-screen pl-6">
           <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-8">
            Terms & Conditions
          </h2>


            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mx-auto">
              <div className="flex items-center justify-center gap-3 mb-8 text-center">
                <img
                  src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/602ab5c89aae71bf9fd0b889c5d6d9fdf098545c?placeholderIfAbsent=true"
                  alt="ONE-STEP Logo"
                  className="w-12 h-12 rounded-full object-cover"
                />
                <h2 className="text-2xl font-bold">One Stop Wedding Dresses</h2>
              </div>

              <div className="space-y-5 text-gray-700 leading-relaxed">
                <p>
                  By accessing or using our website, you agree to be bound by these Terms & Conditions.
                </p>

                <p className="text-center font-semibold text-3xl">
                  1. Definitions
                </p>
                <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li><strong>“Website”</strong> refers to <a href="https://onestopweddingdresses.com">onestopweddingdresses.com</a>.</li>
  <li><strong>“We,” “us,” or “our”</strong> refer to OnestopWeddingDresses, the operator of the Website.</li>
  <li><strong>“You” or “your”</strong> refer to the user or customer visiting, browsing, or making a purchase from the Website.</li>
  <li><strong>“Products”</strong> refer to sarees, photoshoot costumes, accessories, or any other items available for sale on the Website.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  2. Use of the Website
                </p>
           <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li>You must be 18 years or older to place an order.</li>
  <li>You agree to use this website only for lawful purposes.</li>
  <li>You shall not attempt to hack, disrupt, or misuse the website or its content.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  3. Product Information & Colors
                </p>
           <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li>We strive to display product images as accurately as possible.</li>
  <li>However, colors may vary slightly due to screen/monitor settings and lighting during photography.</li>
  <li>Minor variations in color, pattern, or texture cannot be considered defects.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  4. Pricing & Payment
                </p>
               <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li>All prices are listed in [INR / Currency] and are subject to change without prior notice.</li>
  <li>We reserve the right to correct any errors in pricing or product details.</li>
  <li>Payments are processed securely through [Razorpay / Other payment gateway] or other available methods (UPI, cards, wallets, etc.).</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  5. Orders & Acceptance
                </p>
             <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li>Placing a product in the cart and completing checkout is an offer by you to purchase the product.</li>
  <li>We reserve the right to accept or reject your order for any reason, including but not limited to:
    <ul>
      <li>Product out of stock</li>
      <li>Payment issues</li>
      <li>Error in product information or pricing</li>
    </ul>
  </li>
  <li>On successful order, you will receive an Order Confirmation via email/SMS/WhatsApp.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  6. Shipping & Delivery
                </p>
               <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li>Shipping timelines and charges are specified on our Shipping Policy page.</li>
  <li>Delivery dates are estimated and may vary due to courier delays, festivals, or unforeseen events.</li>
  <li>Risk of loss passes to you upon delivery at the provided address.</li>
</ul>

                <p className="text-center font-semibold text-3xl">
                  7. Cancellation, Returns & Refunds
                </p>
            <ul className="list-disc pl-6 rounded-xl space-y-1">
  <li>Please refer to our Cancellation & Refund Policy page for detailed terms.</li>
  <li>By placing an order, you agree to the rules mentioned there.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  8. Intellectual Property
                </p>
            <ul className="list-disc pl-6 rounded-xl space-y-1"> 
  <li>All content on this website (logo, photos, text, designs) is the property of [Brand Name / Owner] or used with permission.</li>
  <li>You may not copy, reproduce, distribute, or use any content without our written consent.</li>
</ul>

                <p className="text-center font-semibold text-3xl">
                  9. Third-Party Links
                </p>
             <ul className="list-disc pl-6 rounded-xl space-y-1"> 
  <li>Our website may contain links to third-party websites. We are not responsible for their content, policies, or practices.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  10. Limitation of Liability
                </p>
          <ul className="list-disc pl-6 rounded-xl space-y-1"> 
  <li>We are not liable for any indirect, incidental, or consequential damages arising out of the use or inability to use our website or products.</li>
  <li>Our maximum liability, if any, shall be limited to the order value paid by you.</li>
</ul>

                <p className="text-center font-semibold text-3xl">
                  11. Governing Law
                </p>
                 <ul className="list-disc pl-6 rounded-xl space-y-1"> 
  <li>These Terms shall be governed by and construed in accordance with the laws of India, and disputes shall be subject to the jurisdiction of courts at Vizianagaram.</li>
</ul>


                <p className="text-center font-semibold text-3xl">
                  12. Changes to Terms
                </p>
              <ul className="list-disc pl-6 rounded-xl space-y-1"> 
  <li>We may update these Terms & Conditions at any time.</li>
  <li>Changes will be posted on this page with the updated date.</li>
  <li>Continued use of the website after such changes constitutes your acceptance.</li>
</ul>

              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Terms;
